module.exports = __webpack_public_path__ + "static/media/loans.f392d809.svg";